import { AppStore, shouldShowLoadingIndicator } from '@tom-ui/utils'
import { InternalAxiosRequestConfig } from 'axios'

export const onFulfilled = (appStore: AppStore) => {
  return (request: InternalAxiosRequestConfig<any>) => {
    if (
      shouldShowLoadingIndicator(
        window.location.pathname,
        request.url ? new URL(request.url, window.location.origin).pathname : undefined,
      )
    ) {
      appStore.increaseLoadingCounter()
    }

    return request
  }
}

export const onRejected = (appStore: AppStore) => {
  return (error: any) => {
    if (
      shouldShowLoadingIndicator(
        window.location.pathname,
        error.config?.url ? new URL(error.config.url, window.location.origin).pathname : undefined,
      )
    ) {
      appStore.decreaseLoadingCounter()
    }

    return Promise.reject(error)
  }
}
